import * as s from "./SideNavBarStyled";
import * as mediaQuery from "components/MediaQuery";
import { MenuItem, useProSidebar } from "react-pro-sidebar";
import { Fragment } from "react";
import { COLORS } from "styles/colors";
import { Text } from "components/atoms/text/Text";
import RBACWrapper from "../function/RBACWrapper";
import { RequiredPermissionType } from "utils/MenuUtil";
import { RoutesProps } from "api/interfaces/menuInterface.interface";
import { useMenu } from "hook/useMenu";
import * as MediaQuery from "components/MediaQuery";

type SideBarProps = {
  idx: number;
  item: RoutesProps;
  currentLink: boolean;
};

function MenuItemComponent({
  idx,
  item,
  currentLink,
}: SideBarProps): JSX.Element {
  const { menuNavigation } = useMenu({});
  const isMobile = MediaQuery.useIsMobile();
  const { collapseSidebar } = useProSidebar();

  const onClick = () => {
    menuNavigation({ to: item.routeName as string });
    if (isMobile) {
      collapseSidebar();
    }
  };

  if (!item.ishidden) {
    return (
      <RBACWrapper
        requiredPermissions={item.isRole as RequiredPermissionType}
        isMenu
      >
        <MenuItem
          key={item.name}
          icon={item.svg}
          active={currentLink}
          disabled={item.disabled}
          onClick={onClick}
          data-testid={`blocks-sidenav-sidenav-menu-item-click-${item.name}`}
        >
          <Text
            className="menu-item-label"
            fontSize={14}
            bold
            color={currentLink ? COLORS.COMPANY : COLORS.SIDEBARMENU}
          >
            {item.name}
          </Text>
        </MenuItem>
      </RBACWrapper>
    );
  }
  return <></>;
}

export default MenuItemComponent;
